var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFwaStatusOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9624_21426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.4805C18.5 15.7942 15.8137 18.4805 12.5 18.4805C9.18629 18.4805 6.5 15.7942 6.5 12.4805C6.5 9.16676 9.18629 6.48047 12.5 6.48047C15.8137 6.48047 18.5 9.16676 18.5 12.4805Z",
    fill: "#E03127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.4805C18 15.518 15.5376 17.9805 12.5 17.9805V18.9805C16.0899 18.9805 19 16.0703 19 12.4805H18ZM12.5 17.9805C9.46243 17.9805 7 15.518 7 12.4805H6C6 16.0703 8.91015 18.9805 12.5 18.9805V17.9805ZM7 12.4805C7 9.4429 9.46243 6.98047 12.5 6.98047V5.98047C8.91015 5.98047 6 8.89062 6 12.4805H7ZM12.5 6.98047C15.5376 6.98047 18 9.4429 18 12.4805H19C19 8.89062 16.0899 5.98047 12.5 5.98047V6.98047Z",
    fill: "#9D231B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9624_21426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.480469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwaStatusOffline);
export default __webpack_public_path__ + "static/media/fwa-status-offline.a576e19443197dda87192626419115de.svg";
export { ForwardRef as ReactComponent };